/// <reference path="../../../node_modules/@types/globalize/index.d.ts" />

namespace Teva {
    export interface MoveableOptions {
        Container: any;
        Handle?: any;
        Dragged?: any;
        IsRTL?: boolean;
        StepSize?: number;
        Threshold?: number;
        PreventOverClass?: any;
        OnStart?: any;
        OnStop?: any;
    }

    export class Moveable {
        static Enable($Elements, Options: MoveableOptions) {
            Options = $.extend({}, Moveable.GetDefaults(), Options);
            Options.Container = $(Options.Container);

            $Elements.each(function () {
                Moveable.InnerEnable($(this), Options);
            });
        }
        static InnerEnable($Element, Options: MoveableOptions) {
            if ($Element.data("moveable") == "1")
                return;

            $Element.data("moveable", "1");

            var $Handle;
            if (Options.Handle === null)
                $Handle = $Element;
            else
                $Handle = $Element.find(Options.Handle);

            $Handle.addClass("teva-moveable-cursor");
            var $Dragged;
            var ThresholdPassed: boolean;
            var Dragged_OriginalTop;
            var Dragged_OriginalLeft;
            var Dragged_OriginalZIndex;
            var RemoveOnRollback;

            var MouseUp;
            $Handle.on("mousedown.moveable touchstart.moveable", function (Event) {
                var IsTouch = Event.type == "touchstart";
                if (Event.which != 1 && !IsTouch)
                    return;

                RemoveOnRollback = false;
                if ($Handle[0] == $Element[0] && $Element[0].getAttribute("onclick") != null) {
                    $Element
                        .data("onclick", $Element[0].getAttribute("onclick"))
                        .attr("onclick", null);
                }
                if ($(Event.target).closest(".teva-dropdown, .og-button-ui-action, .modal-close").length > 0)
                    return true;

                if (Options.Handle === null)
                    $Dragged = $Handle.addClass("teva-moveable-dragged");
                else {
                    if (Options.Dragged != null)
                        $Dragged = $Handle.closest(Options.Dragged);
                    else
                        $Dragged = $Handle.parent().addClass("teva-moveable-dragged");
                }

                var StartX = IsTouch ? (<any>Event.originalEvent).touches[0].pageX : Event.pageX;
                var StartY = IsTouch ? (<any>Event.originalEvent).touches[0].pageY : Event.pageY;

                if (Options.Container[0].tagName == "BODY") {
                    Dragged_OriginalLeft = $Dragged.offset().left - window.pageXOffset;
                    Dragged_OriginalTop = $Dragged.offset().top - window.pageYOffset;
                }
                else if ($Dragged.closest(Options.Container).length == 0) {
                    Options.Container.append($Dragged);
                    $Dragged.css("left", "0px");
                    $Dragged.css("top", "0px");

                    Dragged_OriginalLeft = StartX - Options.Container.offset().left - $Dragged.width() / 2;
                    Dragged_OriginalTop = StartY - Options.Container.offset().top - $Dragged.height() / 2;
                    RemoveOnRollback = true;
                }
                else {
                    Dragged_OriginalLeft = $Dragged.position().left;
                    Dragged_OriginalTop = $Dragged.position().top;
                }
                Dragged_OriginalZIndex = $Dragged.css('z-index');

                var Dragged_Width = Math.ceil(parseFloat(window.getComputedStyle($Dragged[0]).width));
                var Dragged_Height = $Dragged.outerHeight(true);

                ThresholdPassed = false;

                $Dragged
                    .data("moveable.originalwidth", $Dragged[0].style.width == "" || $Dragged[0].style.width == "auto" ? "auto" : $Dragged.css("width"))
                    .css("width", Dragged_Width);

                $(document).on(IsTouch ? "touchmove.moveable" : "mousemove.moveable", function (Event) {
                    if ($Dragged == null)
                        return;

                    var CurrentTop = Dragged_OriginalTop + ((IsTouch ? (<any>Event.originalEvent).touches[0].pageY : Event.pageY) - StartY);
                    if (CurrentTop > Options.Container.height() - Dragged_Height) {
                        if (Dragged_Height < Options.Container.height())
                            CurrentTop = Options.Container.height() - Dragged_Height;
                        else if (CurrentTop > Dragged_OriginalTop)
                            CurrentTop = Dragged_OriginalTop;
                    }
                    if (CurrentTop < 0)
                        CurrentTop = 0;

                    var CurrentLeft = Dragged_OriginalLeft + ((IsTouch ? (<any>Event.originalEvent).touches[0].pageX : Event.pageX) - StartX);
                    if (CurrentLeft > Options.Container.width() - Dragged_Width)
                        CurrentLeft = Options.Container.width() - Dragged_Width;
                    if (CurrentLeft < 0)
                        CurrentLeft = 0;
                    CurrentTop = Moveable.GetRounding(Options, CurrentTop);
                    CurrentLeft = Moveable.GetRounding(Options, CurrentLeft);

                    if (!ThresholdPassed) {
                        if (Options.IsRTL)
                            ThresholdPassed = Options.Threshold <= Math.abs(Dragged_OriginalLeft - CurrentLeft);
                        else
                            ThresholdPassed = Options.Threshold <= Math.abs(CurrentLeft - Dragged_OriginalLeft);
                        ThresholdPassed = ThresholdPassed || Options.Threshold <= Math.abs(CurrentTop - Dragged_OriginalTop);

                        if (ThresholdPassed && Options.OnStart != null)
                            Options.OnStart();
                    }

                    if ($Dragged.css("position") == "relative")
                        $Dragged.css("position", "absolute");
                    if (Options.IsRTL)
                        $Dragged.css("right", (Options.Container.width() - CurrentLeft - $Dragged.outerWidth(true)) + "px").css("left", "auto");
                    else
                        $Dragged.css("left", CurrentLeft + "px").css("right", "auto");
                    $Dragged.css("top", CurrentTop + "px").css("z-index", 1001);
                });
                $(document).on(IsTouch ? "touchend.moveable" : "mouseup.moveable", function (Event) {
                    MouseUp(Event);
                    Event.preventDefault();
                });
                $Handle.on(IsTouch ? "touchend.moveable" : "mouseup.moveable", function (Event) {
                    MouseUp(Event);
                    Event.preventDefault();
                });

                Event.preventDefault();
            });

            MouseUp = function (Event) {
                var IsTouch = Event.type == "touchend";
                if ($Dragged == null)
                    return;

                $(document)
                    .off(IsTouch ? "touchmove.moveable" : "mousemove.moveable")
                    .off(IsTouch ? "touchend.moveable" : "mouseup.moveable");
                $Handle.off(IsTouch ? "touchend.moveable" : "mouseup.moveable");

                if (!ThresholdPassed && $Element.data("onclick") != null)
                    $Element.attr("onclick", $Element.data("onclick"));

                if (Options.Handle === null)
                    $Dragged.removeClass("teva-moveable-dragged");
                else
                    $Dragged.parent().removeClass("teva-moveable-dragged");

                if (Options.OnStop != null)
                    Options.OnStop($Dragged, ThresholdPassed);

                var Rollback = Moveable.IsOverElement(Options, $Dragged);
                if (Rollback) {
                    if (RemoveOnRollback) {
                        $Dragged.remove();
                        $Dragged = null;
                    }
                    else {
                        $Dragged.animate(
                            {
                                left: Options.IsRTL ? null : Dragged_OriginalLeft,
                                right: Options.IsRTL ? Options.Container.width() - Dragged_OriginalLeft - $Dragged.outerWidth(true) : null,
                                top: Dragged_OriginalTop
                            },
                            {
                                duration: 500,
                                complete: function () {
                                    $Dragged.css('z-index', Dragged_OriginalZIndex);
                                    $Dragged = null;
                                }
                            });
                    }
                }
                else {
                    $Dragged.css('z-index', Dragged_OriginalZIndex);
                    $Dragged = null;
                }
            };
        }

        private static GetDefaults(): MoveableOptions {
            return <MoveableOptions>{
                Container: "body",
                Handle: null,
                IsRTL: document.body.dir == "rtl",
                StepSize: 1,
                Threshold: 10,
                PreventOverClass: null,
                OnStart: null,
                OnStop: null,
            };
        }
        private static IsOverElement(Options: MoveableOptions, $CurrentElement): boolean {
            if (Options.PreventOverClass == null)
                return;

            var Current_Left = $CurrentElement.position().left;
            var Current_Right = Current_Left + $CurrentElement.outerWidth(true);
            var Current_Top = $CurrentElement.position().top;
            var Current_Bottom = Current_Top + $CurrentElement.outerHeight(true);

            var ToReturn = false;
            $(Options.PreventOverClass, $(Options.Container)).each(function () {
                if (this == $CurrentElement[0])
                    return;

                var $OtherElement = $(this);
                var Other_Left = $OtherElement.position().left;
                var Other_Right = Other_Left + $OtherElement.outerWidth(true);
                var Other_Top = $OtherElement.position().top;
                var Other_Bottom = Other_Top + $OtherElement.outerHeight(true);

                var Over_X = Moveable.IsIntersecting(Current_Left, Current_Right, Other_Left, Other_Right);
                var Over_Y = Moveable.IsIntersecting(Current_Top, Current_Bottom, Other_Top, Other_Bottom);

                if (Over_X && Over_Y)
                    ToReturn = true;
            });
            return ToReturn;
        }
        private static IsIntersecting(Range1_From, Range1_To, Range2_From, Range2_To) {
            if (Range1_To <= Range2_From)
                return false;
            if (Range1_From >= Range2_To)
                return false;
            return true;
        }
        private static GetRounding(Options: MoveableOptions, Number: number): number {
            return Math.round(Number / Options.StepSize) * Options.StepSize;
        }
    }
}